import type { IResponseData } from '~/types'
import type { IUser } from '~/components/entity/user/types'
import type { INewsCategory } from '~/components/entity/news-category'
import type { IComment } from '~/components/entity/comment/types'
import type { IOrganization } from '~/components/entity/organization/types'
import type { TNewsCard } from './card'
import type { ICardCard } from '~/components/entity/card/item/types'
import type { ICreditCard } from '~/components/entity/credit/item/types'
import type { IDepositCard } from '~/components/entity/deposit/item/types'
import type { IMoneyTransferCard } from '~/components/entity/money-transfer/types'

export enum NewsType {
  news = 'news',
  article = 'article'
}

export type TNewsType = NewsType.news | NewsType.article

// `model` arrives in the raw API shape, where `ratings` is an object rather than
// the scalar the `*Card` item components expect.
type TLeadRelationModel = (ICardCard | ICreditCard | IDepositCard | IMoneyTransferCard) & {
  ratings?: { average_rate: number | string | null } | null
}

export interface ILeadRelation {
  id: number
  model_type: 'card' | 'credit' | 'deposit' | 'money_transfer'
  organization_type: string | null
  organization_id: number | null
  model_id: number | null
  model: TLeadRelationModel
}

export interface INewsCarouselImage {
  id: number
  url: string
  name: string
  mime_type: string
  size: number
  large: string
  thumbnail: string
  copyright: string
}

export interface INews {
  id: number
  type: TNewsType
  slug: string
  url: string
  title: string
  summary: string
  content: string
  updated_at: string | null
  publication_datetime: string | null
  picture?: string
  largeImage?: string
  user?: IUser
  categories: INewsCategory[]
  tags: INewsTag[]
  poll_ids: number[]
  organizations: IOrganization[]
  comments?: IComment[]
  fullname: string
  category: string | null
  views_count: number | null
  largeImageCopyright: string
  youtube?: string
  carousel?: INewsCarouselImage[]
  disclaimers?: string[]
  audio_url?: string
  likes_count: number | null
  lead_relation?: ILeadRelation
  language?: 'ru' | 'ky'
  alternative_link?: string | null
}

interface INewsTag {
  slug: string
  title: string
}

export type TResponseNewsList = IResponseData<TNewsCard[]>
